export class terminateModel {
  
    constructor(
      public mail: string,
      public passw: string,
      public order_id: any 
    ) {  }
  
  }


// WEBPACK FOOTER //
// ./src/app/create-workspace/http-post-request-object-classes/terminateModel.ts